import { render } from "./ProfileAdmin.vue?vue&type=template&id=4a042798&scoped=true"
import script from "./ProfileAdmin.vue?vue&type=script&lang=js"
export * from "./ProfileAdmin.vue?vue&type=script&lang=js"

import "./ProfileAdmin.vue?vue&type=style&index=0&id=4a042798&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a042798"]])

export default __exports__